import { Component, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Utility } from 'src/app/services/utility';
import { Api } from '../../services/api';
import { Globals } from '../../services/globals';
import * as _ from 'lodash';
import { IAdminNotification } from '../../../../../../common/common-interfaces/admin-notification';
import { MatMenu } from '@angular/material/menu';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'store',
    templateUrl: './store.component.html',
    styleUrls: ['./store.component.scss'],
    standalone: false
})
export class StoreComponent {
  sku?: string;
  barcode?: string;
  result?: string;
  onboardingDialogOpened = false;
  activatingReviewMode = false;
  reviewModeActivationError = '';
  @ViewChild('toolsMenu', { static: false }) toolsMenu: MatMenu;
  @ViewChild('storesMenu', { static: false }) storesMenu: MatMenu;
  @ViewChild('adminMenu', { static: false }) adminMenu: MatMenu;
  @ViewChild('onboardingPendingDialog', { static: true }) onboardingPendingDialog: TemplateRef<any>;

  private paramsSubscription?: Subscription;
  constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals, public utility: Utility, private dialog: MatDialog) {
    globals.newFeatures = window.location.hash.includes('new');
  }

  async ngOnInit() {
    this.paramsSubscription = this.route.params.subscribe(async (params: any) => {
      this.globals.loadAdminKey();
      await this.api.loadCurrentUser();
      this.globals.applyUserTheme();
      this.globals.storeId = params.storeId;
      //  this.globals.storeName = params.storeName;
      //this.globals.accessCode = params.accessCode;
      this.globals.storeSettings = await this.api.store().get<any>(`/settings`);
      if(!this.globals.storeSettings.enabledFeatures){
        this.globals.storeSettings.enabledFeatures = {

        };
      }
      this.globals.accessCode = this.globals.storeSettings.accessCode;

      document.title = `${_.capitalize(this.globals.storeSettings.name)} - ACE Gateway`;
      this.openOnboardingPendingDialog();

      if(this.globals.currentUser){
        this.globals.stores = await this.api.user().get<any>(`/current/stores`);
      }

    });
  }

  forceOpenOnboardingDialog() {
    this.dialog.open(this.onboardingPendingDialog, {
      maxWidth: '680px',
      width: 'calc(100vw - 32px)',
      panelClass: 'onboarding-pending-dialog',
      autoFocus: false,
    });
  }

  openOnboardingPendingDialog() {
    if (this.onboardingDialogOpened || !this.globals.storeSettings?.onboardingPending) {
      return;
    }

    this.onboardingDialogOpened = true;
    this.dialog.open(this.onboardingPendingDialog, {
      maxWidth: '680px',
      width: 'calc(100vw - 32px)',
      panelClass: 'onboarding-pending-dialog',
      autoFocus: false,
    });
  }

  async activateReviewMode() {
    this.activatingReviewMode = true;
    this.reviewModeActivationError = '';
    try {
      const result = await this.api.store().post<any>('/review-mode/activate', {});
      this.globals.storeSettings.reviewMode = result.reviewMode;
      this.globals.storeSettings.reviewModeCredits = result.reviewModeCredits;
      this.globals.storeSettings.reviewModeActivatedAt = new Date();
      this.globals.storeSettings.reviewModeTestCreditsGranted =
        (this.globals.storeSettings.reviewModeTestCreditsGranted ?? 0) + result.creditsGranted;
    }
    catch (e: any) {
      this.reviewModeActivationError = e?.error?.message || 'Review mode could not be activated. Please try again.';
    }
    finally {
      this.activatingReviewMode = false;
    }
  }


  ngOnDestroy(): void {
    document.body.classList.remove('shopify-user-theme');
    (this.paramsSubscription as Subscription).unsubscribe();
  }

}
